import React, { useState, useEffect } from 'react'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import AuthenticatedRoute from './pages/authenticatedRoute'

import Home from './pages/home'
import Home2 from './pages/home2'
import NavBar from './components/layout/NavBar'
import Sidebar from './components/layout/Sidebar'
import MobileMenuButton from './components/layout/MobileMenuButton'
import AlertComponent from './components/layout/AlertComponent'
import WhatsAppButton from './components/layout/WhatsAppButton'

import Login from './pages/login'
import RestorePassword from './components/users/RestorePassword'
import ValidateEmail from './pages/ValidateEmail'

import AddUser from './components/users/AddUser'
import AddUserWithPlan from './components/users/AddUserWithPlan'
import AddHostUser from './components/users/AddHostUser'
import AddHostUserCode from './components/users/AddHostUserCode'
import Users from './components/users/Users'
import Photos from './components/catalogs/Photos'
import User from './components/users/User'
import UpdateOwnInfo from './components/users/UpdateOwnInfo'

import Plans from './components/plans/Plans'
import Plan from './components/plans/Plan'
import AddPlan from './components/plans/AddPlan'
import UpdatePlan from './components/plans/UpdatePlan'

import Sessions from './components/sessions/Sessions'
import Session from './components/sessions/Session'
import AddSession from './components/sessions/AddSession'
import SessionSetup from './components/sessions/SessionSetup'

import Licenses from './components/licenses/Licenses'
import SelectPlan from './components/plans/SelectPlan'
import UpdateLicenses from './components/licenses/UpdateLicenses'
import AddPhoto from './components/catalogs/AddPhoto'
import Category from './components/catalogs/Category'
import Canvas from './components/canvas/Canvas'
import QuestionsList from './components/questions/QuestionsList'
import AddQuestions from './components/questions/AddQuestions'
import UpdateQuestions from './components/questions/UpdateQuestions'
import ReportList from './components/report/ReportList'
import SessionReports from './components/report/SessionReports'
import Tutorials from './pages/Tutorials'
import Manuals from './pages/Manuals'
import { useUserContext } from './context/users/UserContext'

// WhatsApp flotante: oculto salvo que definas REACT_APP_SHOW_WHATSAPP_BUTTON=true en .env (reiniciar dev server)
const showWhatsAppButton = process.env.REACT_APP_SHOW_WHATSAPP_BUTTON === 'true'

const APP_ROLES_NON_INVITADO = ['ADMIN', 'ANFITRION_ORG', 'ANFITRION_PER', 'ANFITRION']

function isInvitadoOnlyUser(authenticatedUser, isAuthenticated) {
  if (!isAuthenticated || !authenticatedUser || !Array.isArray(authenticatedUser.permissions)) {
    return false
  }
  return (
    authenticatedUser.permissions.includes('INVITADO') &&
    !authenticatedUser.permissions.some((r) => APP_ROLES_NON_INVITADO.includes(r))
  )
}

function isSessionsListOrCanvasPath(pathname) {
  if (pathname === '/sessions' || pathname.startsWith('/sessions/')) return true
  if (pathname.startsWith('/sesion/')) return true
  if (pathname.startsWith('/host/sesion/')) return true
  return false
}

function AppContent() {
  const { isAuthenticated, authenticatedUser } = useUserContext()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false)
  }

  useEffect(() => {
    if (!isAuthenticated) {
      setIsMobileMenuOpen(false)
    }
  }, [isAuthenticated])

  const invitadoOnly = isInvitadoOnlyUser(authenticatedUser, isAuthenticated)
  const hideMobileMenuForInvitadoOnSessionsOrCanvas =
    invitadoOnly && isSessionsListOrCanvasPath(location.pathname)

  useEffect(() => {
    if (hideMobileMenuForInvitadoOnSessionsOrCanvas) {
      setIsMobileMenuOpen(false)
    }
  }, [hideMobileMenuForInvitadoOnSessionsOrCanvas])

  // Escuchar el evento personalizado del botón hamburguesa del home (solo usuarios autenticados)
  useEffect(() => {
    const handleToggleMobileMenu = () => {
      if (!isAuthenticated) return
      if (hideMobileMenuForInvitadoOnSessionsOrCanvas) return
      setIsMobileMenuOpen(true)
    }

    window.addEventListener('toggleMobileMenu', handleToggleMobileMenu)
    
    return () => {
      window.removeEventListener('toggleMobileMenu', handleToggleMobileMenu)
    }
  }, [isAuthenticated, hideMobileMenuForInvitadoOnSessionsOrCanvas])

  // Ocultar hamburguesa en login, sin sesión, o invitado solo en lista/detalles de sesiones y canvas
  const isLoginPage = location.pathname === '/'
  const showMobileMenuChrome =
    !isLoginPage &&
    isAuthenticated &&
    !hideMobileMenuForInvitadoOnSessionsOrCanvas

  return (
    <div className='App'>
      <AlertComponent />
      {/* <NavBar /> */}
      {showMobileMenuChrome && (
        <MobileMenuButton 
          isOpen={isMobileMenuOpen} 
          onToggle={handleMobileMenuToggle} 
        />
      )}
      {showMobileMenuChrome && (
        <div 
          className={`mobile-menu-overlay ${isMobileMenuOpen ? 'show' : ''}`}
          onClick={handleMobileMenuClose}
        ></div>
      )}
        <div style={{ display: 'flex', height: '100vh' }}>
          <Sidebar 
            isMobileMenuOpen={isMobileMenuOpen}
            onMobileMenuClose={handleMobileMenuClose}
          />
          <div className='w-100 main-content' style={{ transition: 'margin-left 0.3s ease' }}>
            <Routes>
              <Route exact path='/' element={<Login />} />
              <Route exact path='/welcome' element={<Home2 />} />
              <Route path='/home' element={
                <AuthenticatedRoute>
                  <Home />
                </AuthenticatedRoute>
              } />

              {/* <Route path='/welcome' element={
                <AuthenticatedRoute>
                  <Home2 />
                </AuthenticatedRoute>
              } /> */}

              <Route path='/usuarios' element={
                <AuthenticatedRoute>
                  <Users />
                </AuthenticatedRoute>
              } />
              <Route path='/usuarios/:id' element={
                <AuthenticatedRoute>
                  <User />
                </AuthenticatedRoute>
              } />
              <Route path='/usuario' element={
                <AuthenticatedRoute>
                  <AddUser />
                </AuthenticatedRoute>
              } />
              <Route path='/informacionPersonal' element={
                <AuthenticatedRoute>
                  <UpdateOwnInfo />
                </AuthenticatedRoute>
              } />

              <Route path='/fotografias' element={
                <AuthenticatedRoute>
                  <Photos />
                </AuthenticatedRoute>
              } />

              <Route path='/fotografias/agregar' element={
                <AuthenticatedRoute>
                  <AddPhoto />
                </AuthenticatedRoute>
              } />


              <Route path='/categorias' element={
                <AuthenticatedRoute>
                  <Category />
                </AuthenticatedRoute>
              } />

              <Route path='/planes' element={
                <AuthenticatedRoute>
                  <Plans />
                </AuthenticatedRoute>
              } />
              <Route path='/planes/:id' element={
                <AuthenticatedRoute>
                  <Plan />
                </AuthenticatedRoute>
              } />
              <Route path='/planes/:id/actualizar' element={
                <AuthenticatedRoute>
                  <UpdatePlan />
                </AuthenticatedRoute>
              } />
              <Route path='/plan' element={
                <AuthenticatedRoute>
                  <AddPlan />
                </AuthenticatedRoute>
              } />

              <Route path='/licencias' element={
                <AuthenticatedRoute>
                  <Licenses />
                </AuthenticatedRoute>
              } />
              <Route path='/licencias/:id' element={
                <AuthenticatedRoute>
                  <UpdateLicenses />
                </AuthenticatedRoute>
              } />

              {/* <Route path='/Canvas' element={
                <AuthenticatedRoute>
                  <Canvas />
                </AuthenticatedRoute>
              } /> */}

              {/* <Route path='/sesion/:id' element={
                <AuthenticatedRoute>
                  <Canvas />
                </AuthenticatedRoute>
              } /> */}

              <Route path='/sessions' element={
                <AuthenticatedRoute>
                  <Sessions />
                </AuthenticatedRoute>
              } />
              <Route path='/sessions/:id' element={
                <AuthenticatedRoute>
                  <Session />
                </AuthenticatedRoute>
              } />
              <Route path='/sessions/:id/actualizar' element={
                <AuthenticatedRoute>
                  <UpdatePlan />
                </AuthenticatedRoute>
              } />
              <Route path='/session' element={
                <AuthenticatedRoute>
                  <AddSession />
                </AuthenticatedRoute>
              } />
              <Route path='/session/:id/setup' element={
                <AuthenticatedRoute>
                  <SessionSetup />
                </AuthenticatedRoute>
              } />

              <Route path='/preguntas' element={
                <AuthenticatedRoute>
                  <QuestionsList />
                </AuthenticatedRoute>
              } />

              <Route path='/preguntas/agregar' element={
                <AuthenticatedRoute>
                  <AddQuestions />
                </AuthenticatedRoute>
              } />

              <Route path='/preguntas/:id/actualizar' element={
                <AuthenticatedRoute>
                  <UpdateQuestions />
                </AuthenticatedRoute>
              } />


              <Route path='/reportes' element={
                <AuthenticatedRoute>
                  <ReportList />
                </AuthenticatedRoute>
              } />

              <Route path='/reporte' element={
                <AuthenticatedRoute>
                  <SessionReports />
                </AuthenticatedRoute>
              } />

              <Route path='/tutoriales' element={
                <AuthenticatedRoute>
                  <Tutorials />
                </AuthenticatedRoute>
              } />

              <Route path='/manuales' element={
                <AuthenticatedRoute>
                  <Manuals />
                </AuthenticatedRoute>
              } />

              <Route path='/login' element={<Login />} />
              <Route path='/seleccionaPlan' element={<SelectPlan />} />
              <Route path='/sesion/:id' element={<Canvas />} />
              <Route path='/host/sesion/:id' element={
                <AuthenticatedRoute>
                  <Canvas />
                </AuthenticatedRoute>
              } />
              <Route path='/password/:userToken/restore' element={<RestorePassword />} />
              <Route path='/validateEmail/:userToken' element={<ValidateEmail />} />
              <Route exact path='/getPlan' element={<AddUserWithPlan />} />
              <Route exact path='/hostUser' element={<AddHostUser />} />
              <Route exact path='/hostUserCode' element={<AddHostUserCode />} />
            </Routes>
          </div>
        </div>
        {showWhatsAppButton && <WhatsAppButton />}
      </div>
  )
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App
